<template>
  <div class="wrap">
    <div class="introduce" v-if="!isMobile">
      <!--      <span>Copyright © 义乌市筑真电子科技有限公司 丨 <el-link href="https://beian.miit.gov.cn"><span>浙ICP备13019736号-7</span></el-link> </span>-->
    </div>
    <div class="login">
      <h1>玩多多</h1>
      <div class="info-input">
        <el-input placeholder="请输入您的账号" v-model="account"></el-input>
        <el-input placeholder="请输入您的密码" v-model="password" @keypress.enter.native="login" type="password"></el-input>
      </div>
      <el-row>
        <el-col :span="24">
          <el-button :loading="loading" @click="login()">登&nbsp;&nbsp;录</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import store from '../store/index.js'
export default {
  name: 'Login',
  data () {
    return {
      isMobile: false,
      account: '', // 账号输入框
      password: '', // 密码
      phone: '',
      loading: false // 登录加载中
    }
  },
  mounted () {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },
  methods: {
    ...mapMutations(['setToken', 'setRegisterUserInfo']),
    // 忘记密码 设置新密码
    login () {
      this.accountLogin()
    },
    // 账号登录
    accountLogin () {
      if (this.loading) {
        return
      }
      if (!this.check()) {
        return
      }
      // this.loading = true
      axios.post('api/sysUser/sysUserLogin?account=' + this.account + '&password=' + this.password + '&code=0').then((res) => {
        if (res && res.data.code === 200) {
          this.$message({
            type: 'success',
            message: res.data.result.msg,
            duration: 1000
          })
          // 将token和sysuserinfo保存到localStorage中
          store.commit('setToken', res.data.result.token)
          store.commit('setSysUserInfo', res.data.result.sysUserInfo)
          // 获取本地存储中的registeruser
          this.sysUserInfo = JSON.parse(localStorage.getItem('sysUserInfo'))
          // console.log(this.registeruser)
          this.$router.push('/ft')
          window.location.href = '/ft'
          /* if (this.isMobile) {
            this.$router.push('/appOrder')
            window.location.href = '/appOrder'
          } else {
            this.$router.push('/ft')
            window.location.href = '/ft'
          } */

          /* setTimeout(() => {
            let newUrl = this.$router.resolve('/ft')
            window.open(newUrl.href, '_blank')
            this.loading = false
          }, 1500) */
        } else {
          this.$message({
            type: 'fail',
            message: res.data.result.msg
          })
        }
        this.loading = false
      }).catch(function (err) {
        console.log(err)
      })
    },
    // 登录前验证
    check () {
      if (this.account.trim() === '') {
        this.$message.error('账号不能为空')
        return false
      }
      if (this.password.trim() === '') {
        this.$message.error('密码不能为空')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/style/variable";
.wrap {
  display: flex;
  width: 100%;
  height: 100%;
  // 左边介绍
  .introduce {
    //padding-left: 10%;
    width: 30%;
    height: 100%;
    box-sizing: border-box;
    color: #fff;
    // background-image: url("../../static/main.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    // background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    h2 {
      font-size:14px;
      font-style: italic;
      font-weight: 900;
      margin-top: 50px;
    }
    h3 {
      font-size: 49px;
      font-weight: 300;
      margin: 25px 0;
    }
    span {
      font-size:14px;
      padding-top: 85%;
    }
  }
  // 右边登录
  .login {
    height: 100%;
    width: 70%;
    max-width: 840px;
    flex-shrink: 0;
    text-align: center;
    background: #fff;
    padding: 0 8%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    h1 {
      font-size: 28px;
      font-weight: 500;
    }
    .info-input {
      margin-top: 32px;
      margin-bottom: 62px;
      /deep/ .el-input {
        margin-top: 38px;
        .el-input__inner {
          height: 50px;
          background: #F9F9F9;
          border: 1px solid transparent;
          &:focus {
            border: 1px solid @primary-color;
          }
        }
      }
    }
    .el-button {
      height: 50px;
      width: 100%;
      color: #fff;
      font-size: 16px;
      background: linear-gradient(130deg,@primary-color + 20 0%,@primary-color - 20 100%);
    }
  }
}
.wrap {
  /*... existing styles ...*/
  overflow: hidden;
  // Mobile styles (assuming breakpoint at 768px for tablets and below)
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;

    // Login styles for mobile
    .login {
      width: 100%; // Takes the full width in mobile view
      padding: 5%; // Reduced padding for more space

      h1 {
        font-size: 24px; // Adjusted font size for mobile
      }

      .info-input {
        margin-top: 20px;
        margin-bottom: 30px;
      }

      .el-button {
        height: 45px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue